export default __webpack_public_path__ + "static/media/copyright_cc.7accd90c.svg";